import React from 'react';
import { PropTypes } from 'prop-types';
import styles from './Navigation.css';
import Menu from './Menu';
import PatientInfo from './PatientInfo';
import Logos from './Logos';

const Navigation = ({ patient, vetPractice }) => (
  <div className={styles.containerWrap}>
    <Menu />
    <div className={styles.container}>
      <div className={styles.navigation}>
        <PatientInfo patient={patient} vetPractice={vetPractice} />
      </div>
    </div>
    <Logos smallLogos />
  </div>
);

Navigation.propTypes = {
  patient: PropTypes.string,
  vetPractice: PropTypes.string,
};

export default Navigation;



// WEBPACK FOOTER //
// ./src/components/Navigation.jsx